import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { useAuthStore } from "../stores/auth";
import logo from "../assets/logo.png";

export function TopBar() {
  const { user, memberships, currentTenant, selectTenant, logout } =
    useAuthStore();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  if (!user) return null;

  const toggleLang = () => {
    i18n.changeLanguage(i18n.language === "fr" ? "en" : "fr");
  };

  return (
    <header className="bg-white border-b border-slate-200">
      <div className="max-w-6xl mx-auto px-6 h-14 flex items-center justify-between">
        <div className="flex items-center gap-6">
          <img src={logo} alt="HInvoice" className="h-9 w-auto" />
          {memberships.length > 1 && (
            <label className="flex items-center gap-2 text-sm text-slate-600">
              <span>{t("topbar.tenant")} :</span>
              <select
                className="border border-slate-300 rounded-md px-2 py-1 text-sm bg-white"
                value={currentTenant?.id ?? ""}
                onChange={async (e) => {
                  const id = e.target.value;
                  if (id) await selectTenant(id);
                }}
              >
                {!currentTenant && (
                  <option value="">{t("topbar.chooseTenant")}</option>
                )}
                {memberships.map((m) => (
                  <option key={m.tenant.id} value={m.tenant.id}>
                    {m.tenant.name}
                  </option>
                ))}
              </select>
            </label>
          )}
          {memberships.length === 1 && currentTenant && (
            <span className="text-sm text-slate-500">{currentTenant.name}</span>
          )}
        </div>

        <div className="flex items-center gap-4 text-sm">
          {/* Sélecteur de langue */}
          <button
            type="button"
            onClick={toggleLang}
            title={i18n.language === "fr" ? "Switch to English" : "Passer en français"}
            className="flex items-center gap-1.5 px-2 py-1 rounded-md border border-slate-200 text-slate-600 hover:bg-slate-50 transition-colors text-xs font-medium"
          >
            <span className="text-base leading-none">
              {i18n.language === "fr" ? "🇫🇷" : "🇬🇧"}
            </span>
            <span>{i18n.language === "fr" ? "FR" : "EN"}</span>
          </button>

          <span className="text-slate-600">{user.email}</span>
          <button
            type="button"
            className="text-slate-500 hover:text-slate-800"
            onClick={async () => {
              await logout();
              navigate("/login");
            }}
          >
            {t("topbar.logout")}
          </button>
        </div>
      </div>
    </header>
  );
}
